<script setup>
import { onMounted, onUnmounted } from 'vue';
import { googleAuth, loadGoogleScripts, gapiInitServico, unloadGoogleScripts} from '@/utils/googleAuth';
import { criarGoogleForms } from '@/utils/criarGoogleForms';
import { criarGoogleDocs } from '@/utils/criarGoogleDocsQuestoes';
import { criarGoogleSlides } from '@/utils/criarGoogleSlidesQuestoes';


const nomeEscola = "ESCOLA SESI DE ENSINO MÉDIO\nAlbino Marques Gomes";
const logoEscola = "https://res.cloudinary.com/dzsqhh2hh/image/upload/v1716735676/jesiadaoylfzmbsavrqy.png";
const questoes = [
    {   
        imagem: "https://static.todamateria.com.br/upload/as/su/assuntosdequimicanoenem2-cke.jpg",
        texto: "Esta é uma pergunta de geografia sobre capitais europeias.",
        pergunta: "Qual é a capital da França?",

        a: "Paris",
        b: "Madrid",
        c: "Berlim",
        d: "Lisboa",
        e: "Roma",
        gabarito: "D"
    },
    {   
        imagem: "",
        texto: "Texto bem longo",
        pergunta: "Quem pintou a Mona Lisa?",
        a: "",
        b: "",
        c: "",
        d: "",
        e: "",
        gabarito: ""
    },
    {   imagem: "",
        texto: "",
        pergunta: "Qual é o elemento químico cujo símbolo é 'O'?",
        a: "Oxigênio",
        b: "Osmium",
        c: "Ouro",
        d: "Óxido nítrico",
        e: "",
        gabarito: "B"
    }
];

const titulo = "Teste de Conhecimento Geral";


onMounted(() => {
    loadGoogleScripts('forms');
})

const delay = (ms) => new Promise(resolve => setTimeout(resolve, ms));


async function criarForms() {
    await gapiInitServico('forms');
    await delay(2000);
    let response = await googleAuth();
    if (response) {
        let response = await criarGoogleForms(questoes, titulo);
        if(response.status == 'erro'){
            console.log(response.erro);
            return
        }
        console.log(`https://docs.google.com/forms/d/${response.formId}/edit`);
    }
}

async function criarDocs() {
    await gapiInitServico('docs');
    await delay(2000);
    let response = await googleAuth();
    if (response) {
        let result = await criarGoogleDocs(questoes, titulo);
        console.log(`https://docs.google.com/document/d/${result}/edit`);
    }
}

async function criarSlides() {
    await gapiInitServico('slides');
    await delay(2000);
    let response = await googleAuth();
    if (response) {
      let result =  await criarGoogleSlides(questoes, titulo);
        console.log(`https://docs.google.com/presentation/d/${result}/edit`);
    }
}

</script>

<template>


    <button class="btn btn-primary" @click="criarForms">Acessar o Google Forms</button>
    <button class="btn btn-primary" @click="criarDocs">Acessar o Google Doc</button>
    <button class="btn btn-primary" @click="criarSlides">Acessar o Google Slide</button>
</template>